import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const tableEditingKey: PluginKey = new PluginKey('selectingCells');
export const fixTablesKey: PluginKey = new PluginKey('fix-tables');
